import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Jump"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M1.83956 22.5C2.11124 22.5038 2.36373 22.3603 2.49956 22.125C4.53163 18.6633 8.23554 16.5264 12.2496 16.5V21C12.2511 21.3028 12.4345 21.575 12.7146 21.69C12.9939 21.8075 13.3164 21.7453 13.5321 21.5325L22.5321 12.5325C22.674 12.3917 22.7539 12.2 22.7539 12C22.7539 11.8 22.674 11.6083 22.5321 11.4675L13.5321 2.4675C13.3164 2.25469 12.9939 2.19256 12.7146 2.31C12.4345 2.42506 12.2511 2.69723 12.2496 3V7.5825C5.83119 8.40689 1.01836 13.8614 0.999557 20.3325C1.00133 20.834 1.03389 21.335 1.09706 21.8325C1.13547 22.1525 1.37399 22.4121 1.68956 22.4775L1.83956 22.5ZM12.6266 15C8.75532 14.9444 5.05442 16.5893 2.50156 19.5C2.96768 13.8799 7.44605 9.4301 13.0691 9.00001C13.4567 8.96498 13.7531 8.63923 13.7516 8.25001V4.80751L20.9441 12L13.7516 19.1925V15.75C13.7516 15.3358 13.4158 15 13.0016 15H12.5966H12.6266Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Jump.vue"]]);
